module.exports = __webpack_public_path__ + "static/media/crative-agency.dec21939.jpg";